import React from 'react';

import {Grid} from '@mui/material';
import {useParams} from 'react-router-dom';

import {Head} from '@wheeebo/polaris-ui';

import LoginEventsCard from '@components/pages/member/LoginEventsCard';
import MemberUpdateCard from '@components/pages/member/MemberUpdateCard';

function MemberPage(): JSX.Element {
  const params = useParams();
  return (
    <Grid container spacing={1}>
      <Head title="Member" />
      <Grid item xs={12} sm={8}>
        {params.memberId ? <MemberUpdateCard memberId={params.memberId} /> : null}
      </Grid>
      <Grid item xs={12} sm={4}>
        {params.memberId ? <LoginEventsCard memberId={params.memberId} /> : null}
      </Grid>
    </Grid>
  );
}

export default React.memo(MemberPage);
